import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES } from '../../data/constants'
import { getSubsectionView } from '../../data/scoring'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import WhyThisMatters from '../../components/WhyThisMatters/WhyThisMatters'
import CopilotAddOnAssigned from './CopilotAddOnAssigned'
import CopilotConfiguration from './CopilotConfiguration'
import CopilotEligibleUsers from './CopilotEligibleUsers'

export default function DeploymentReadiness({
  summary = {},
  data = {},
  scoring = { sections: [] },
  dataAvailability = [],
}) {
  const copilotUserLicenseCounts = summary.licensing?.copilot?.userLicenseCounts ?? {}
  const eligibleUsers = getSubsectionView(scoring, 'copilotEligibleUsers')
  const addOnAssigned = getSubsectionView(scoring, 'copilotAddOnAssigned')

  return (
    <>
      <div {...AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES}>
        <SectionHeading
          id="deployment"
          titleId="AI_RISK_REPORT.SECTION.DEPLOYMENT.TITLE"
          questionId="AI_RISK_REPORT.SECTION.DEPLOYMENT.QUESTION"
        />
        <WhyThisMatters bodyId="AI_RISK_REPORT.SECTION.DEPLOYMENT.WHY" />
      </div>
      <CopilotEligibleUsers
        licenses={data.licenses ?? []}
        users={data.copilotUserLicenses ?? []}
        userCounts={copilotUserLicenseCounts}
        score={eligibleUsers.score}
        gap={eligibleUsers.gap}
      />
      <CopilotAddOnAssigned
        summary={summary}
        users={data.copilotUserLicenses ?? []}
        userCounts={copilotUserLicenseCounts}
        score={addOnAssigned.score}
        gap={addOnAssigned.gap}
      />
      <CopilotConfiguration dataAvailability={dataAvailability} />
    </>
  )
}

const summaryPropType = PropTypes.shape({
  licensing: PropTypes.shape({
    copilot: PropTypes.shape({
      userLicenseCounts: PropTypes.shape({
        notEligible: PropTypes.number,
        eligibleWithoutAddOn: PropTypes.number,
      }),
    }),
    eligibleBase: PropTypes.shape({ skuCount: PropTypes.number }),
  }),
})

DeploymentReadiness.propTypes = {
  summary: summaryPropType,
  data: PropTypes.shape({
    licenses: PropTypes.arrayOf(PropTypes.shape({})),
    copilotUserLicenses: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  scoring: PropTypes.shape({ sections: PropTypes.arrayOf(PropTypes.shape({})) }),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
